import {
  Button,
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  IconButton,
} from "@sainsburys-tech/luna-button";
import { SearchField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { Plus, Search } from "@sainsburys-tech/luna-icons";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ISearchForm } from "../../Interfaces/ISearchForm";
import AddFieldModal from "../FamilyGroupAdministration/Management/Create-FamilyGroupManagement/AddFieldModal";
import { ValuesType } from "../../Types/InitialStateType";
import { filterModelSelecterAndProcessData } from "../../helpers/filterModelSelector";
import store from "../../Store/store";
import { storeFilter } from "../../Redux/Actions/filterActions";
import DuTypePopupAdd from "../ContainerTypeMaintenance/Add-DuType/duTypeModalAdd";
import ProductMenu from "../Product/Product-Menu/productMenu";
import { dispatchMessageFormatter } from "../../helpers/dispatchMessageFormatter";
import { storeEditPayload } from "../../Redux/Actions/popupActions";
import { iInitialStateDuType } from "../../Interfaces/IDuType";
import { iInitialStateFamilyGroupManagement } from "../../Interfaces/IFamilyGroupManagement";
import { consolelog } from "../../helpers/consolelog";

const SearchForm = ({
  initialState,
  isDisabled, //setFilters,
  model,
  hasCreateButton,
}: ISearchForm) => {
  const [state, setState] = useState(initialState);
  const [selectedPath, setSelectedPath] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { values, dirty, submitted } = state;
  const user = useSelector((state: any) => state.auth.user);

  const searchResultCount = useSelector(
    (state: any) => state.searchCountReducer
  );

  const {
    data,
    isDirectQuery,
    parentName,
    selectedMenu,
    createPopupName,
    deletePopupName,
    searchPageReset,
    searchId,
    description,
    previousQueryData,
  } = useSelector((state: any) => state.filterReducer.data);

  useEffect(() => {
    setSelectedPath(`${parentName}/${selectedMenu}`);
  }, [selectedMenu]);

  const handleChange = (event: any) => {
    const targetIndex = values.findIndex(
      (obj) => obj.name === event.target.name
    );
    values[targetIndex].value = event.target.value;
    setState((initialState) => {
      return {
        ...initialState,
        values: [...values],
        dirty: true,
      };
    });
    if (values[targetIndex].value == "") {
      consolelog("Data", data);
      const filter = filterModelSelecterAndProcessData(
        state.values,
        selectedPath
      );
      let filterPayload;
      if (!isDirectQuery && event.target.value === "" && previousQueryData) {
        filterPayload = dispatchMessageFormatter(
          previousQueryData,
          isDirectQuery,
          "SearchForm 62",
          selectedMenu,
          parentName,
          createPopupName,
          deletePopupName,
          undefined,
          searchId,
          description,
          undefined,
          undefined,
          undefined
        );
      } else if (!isDirectQuery) {
        filterPayload = dispatchMessageFormatter(
          filter,
          isDirectQuery,
          "SearchForm 65",
          selectedMenu,
          parentName,
          createPopupName,
          deletePopupName,
          undefined,
          searchId,
          description,
          undefined,
          undefined,
          undefined
        );
      } else {
        filterPayload = dispatchMessageFormatter(
          "",
          true,
          "SearchForm 69",
          selectedMenu,
          parentName,
          createPopupName,
          deletePopupName,
          "searchQueryPageReset",
          searchId,
          description,
          undefined,
          undefined,
          undefined
        );
      }
      // let filterPayload = dispatchMessageFormatter(filter, isDirectQuery, selectedMenu, parentName, createPopupName,
      //   deletePopupName, "searchQueryPageReset")
      store.dispatch(storeFilter(filterPayload));
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setState((initialState) => {
      return {
        ...initialState,
        submitted: true,
        dirty: true,
      };
    });
    //Compose filterd data here
    const filter = filterModelSelecterAndProcessData(
      state.values,
      selectedPath
    );
    let filterPayload;
    if (!isDirectQuery) {
      filterPayload = dispatchMessageFormatter(
        filter,
        isDirectQuery,
        "SearchForm 92",
        selectedMenu,
        parentName,
        createPopupName,
        deletePopupName,
        undefined,
        searchId,
        description,
        undefined,
        data,
        state.values[0].value,
        true
      );
    } else {
      filterPayload = dispatchMessageFormatter(
        filter,
        isDirectQuery,
        "SearchForm 96",
        selectedMenu,
        parentName,
        createPopupName,
        deletePopupName,
        "searchQueryPageReset",
        searchId,
        description,
        undefined,
        undefined,
        state.values[0].value,
        true
      );
    }
    store.dispatch(storeFilter(filterPayload));
  };

  const handleAdd = (event: any, eventValue: ValuesType) => {
    event.preventDefault();
    values.push(eventValue);
    setState((initialState) => {
      return {
        ...initialState,
        values: [...values],
        submitted: true,
        dirty: true,
      };
    });
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const clearAll = (e: any) => {
    setState((initialState) => {
      return {
        ...initialState,
        values: values.map((value) => ({
          name: value.name,
          label: value.label,
          value: "",
          searchMethod: "contains",
          searchOperator: "or",
        })),
        submitted: false,
        dirty: false,
      };
    });

    let filterPayload = dispatchMessageFormatter(
      "",
      true,
      "SearchForm 135",
      selectedMenu,
      parentName,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    );
    store.dispatch(storeFilter(filterPayload));
    //setFilters("")
  };

  const openPopUp = () => {
    if (
      parentName === "/containerTypeMaintenance" &&
      selectedMenu === "Management"
    ) {
      store.dispatch(storeEditPayload({ editPayload: iInitialStateDuType }));
    } else if (
      parentName === "/familyGroupAdmin" &&
      selectedMenu === "Management"
    ) {
      store.dispatch(
        storeEditPayload({ editPayload: iInitialStateFamilyGroupManagement })
      );
    }
    setIsModalOpen(true);
  };

  return (
    <Container className="searchPanel ln-u-bg-color-white">
      <GridWrapper equalHeight>
        <GridItem size="1/3">
          <SearchField
            name="Search"
            label="Search"
            //placeholder="Search"
            hasAction
            onChange={(e: any) => handleChange(e)}
            action={
              <Button onClick={(event: any) => handleSubmit(event)}>
                <span className="ln-u-visually-hidden">Search</span>
                <Search />
              </Button>
            }
          />
        </GridItem>
        {hasCreateButton && user?.isLDMAdmin ? (
          <>
            <GridItem size="1/3"> </GridItem>

            <GridItem size="1/3">
              <ButtonGroupWrapper onClick={() => openPopUp()}>
                <ButtonGroupPrimary>
                  <IconButton
                    variant="filled"
                    label="Create New Record"
                    fullWidth
                  >
                    <Plus />
                  </IconButton>
                </ButtonGroupPrimary>
              </ButtonGroupWrapper>
            </GridItem>
          </>
        ) : (
          <>
            <GridItem size="1/3"> </GridItem>
          </>
        )}
      </GridWrapper>

      {isModalOpen &&
        parentName === "/familyGroupAdmin" &&
        selectedMenu === "Management" &&
        createPopupName === "familyGroupCreateManagement" && (
          <AddFieldModal
            isOpen={isModalOpen}
            handleClose={handleClose}
            handleAddCallback={handleAdd}
          />
        )}

      {isModalOpen &&
        parentName === "/containerTypeMaintenance" &&
        selectedMenu === "Management" &&
        createPopupName === "duTypeCreateManagement" && (
          <DuTypePopupAdd
            isOpen={isModalOpen}
            handleClose={handleClose}
            title={"Create new Container Type"}
            isEdit={false}
          />
        )}
    </Container>
  );
};
export default SearchForm;
